module.exports = __webpack_public_path__ + "img/img17.9403203e.svg";